import {CREATE_INVOICE, GET_INVOICE, SEND_INVOICE_EMAIL, UPDATE_INVOICE} from 'admin/gql/Invoice.gql'
import clearCache from 'admin/hooks/clearCache'
import useDestroyable from 'admin/hooks/useDestroyable'
import {useMutation, useQuery} from 'admin/lib/apollo'
import {calculateLineItems} from '../lib/tax'

export default (organisationId, invoiceId) => {
  const {data: {invoice = {}} = {}} = useQuery(GET_INVOICE, {
    variables: {organisationId, invoiceId},
    skip: !invoiceId
  })

  const [create, {error: createError}] = useMutation(CREATE_INVOICE, {
    variables: {organisationId, invoiceId},
    flash: 'Invoice created',
    update: (cache, {data: {invoice}, errors}) =>
      !errors && clearCache({invoices: {organisationId}, statement: {accountId: invoice.account.id}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_INVOICE, {
    variables: {organisationId, invoiceId},
    flash: 'Invoice updated',
    update: (cache, {data: {invoice}, errors}) => {
      if (!errors) {
        clearCache({
          history: {itemType: 'Invoice', itemId: invoiceId},
          statement: {accountId: invoice.account.id}
        })(cache)
      }
    }
  })

  const [send, {error: sendError}] = useMutation(SEND_INVOICE_EMAIL, {
    variables: {organisationId, invoiceId},
    flash: 'Invoice sent',
    update: (cache, {errors}) => !errors && clearCache({history: {itemType: 'Invoice', itemId: invoiceId}})(cache)
  })

  const {destroy, errors: destroyError} = useDestroyable('Invoice', invoiceId)

  return {
    invoice: {
      ...invoice,
      lineItems: calculateLineItems(invoice.lineItems, invoice.taxType),
      credits: calculateLineItems(
        (invoice.credits || []).map(credit => ({
          ...credit,
          quantity: 1,
          unitPrice: -credit.amount,
          totalAmount: -credit.amount
        })),
        invoice.taxType
      ),
      debits: calculateLineItems(
        (invoice.debits || []).map(debit => ({
          ...debit,
          quantity: 1,
          unitPrice: debit.amount,
          totalAmount: debit.amount
        })),
        invoice.taxType
      )
    },
    errors: createError || updateError || sendError || destroyError || {},
    create,
    update,
    destroy,
    send
  }
}
